<script>
  import SubscriptionSelectionArea from './SubscriptionSelectionArea.svelte';
  import USPSection from './USPSection.svelte';
  import InfoBoxSection from './InfoBoxSection.svelte';
  import Footer from './Footer.svelte';
  import Navbar from './Navbar.svelte';
  import { onMount } from 'svelte';
  import { getHost } from './helper';
  import { debounce } from '../../utilities/helpers';

  export let data,
    isRTL = false,
    navbarTopPosition = 7.9,
    urlStyleLocale = 'country/language';

  const sthp = getHost(data);

  const currentSubscription = data.currentSubscription || {};
  const upcomingSubscription = data.upcomingSubscription || {};
  const isCustomerInactive = data.isCustomerInactive || false;
  let cards = [...new Array(data.firstRow.productGroups.length)].map(() => ({}));
  const componentInformationKeys = data.informationKeys;
  const subscriptionCards = data.firstRow.productGroups.length;

  $: subscriptionData = data
    ? {
        ...data,
        componentInformationKeys,
        isCustomerInactive,
        currentSubscription,
        upcomingSubscription,
      }
    : null;

  let didMount = false;
  let bottom;

  $: activeIdx = 0;
  const onScroll = debounce(() => {
    if (!didMount) return -1;
    const scrollY = window.pageYOffset;
    const margin = window.innerHeight / 2;
    // on scroll, figure out what card is at the scrollY position
    // loop cards to check if the y value is more than the card Y position
    activeIdx = [...cards].findIndex((c) => scrollY < c.wrapper.offsetTop - margin) - 1;
    if (activeIdx === -1) activeIdx = 0;
    if (activeIdx === -2) activeIdx = cards.length - 2;
  }, 20);

  const handleNavbarCardSelected = (event) => {
    const oneRem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const { card } = event.detail;
    const topMargin = oneRem * (navbarTopPosition + 7.4); // calculate offset based on navbar position including the navbar height itself
    window.scrollTo({ top: card.wrapper.offsetTop - topMargin, behavior: 'smooth' });
  };

  onMount(() => {
    didMount = true;
    // add another "card" to mark the bottom of the cards.
    cards.push({ wrapper: bottom });
  });
</script>

<style lang="scss">
  @use './index' as *;

  $subscription-area-purple: #48001e;
  $subscription-area-text-white: #fff4f2;

  .background {
    background-color: $pink-10;
    width: 100%;
    padding-block-end: 8.9rem;
  }

  .wrap {
    padding: spacing(8) spacing(2) 0;

    @include mq($from: tabletlandscape) {
      padding-inline: spacing(4);
    }

    .subscription-main-wrapper {
      display: flex;
      width: 100%;
      flex-direction: column;

      @include mq($from: tabletlandscape) {
        flex-direction: row;
        justify-content: space-evenly;
      }

      @include mq($from: desktop) {
        margin-block-start: 0;
        display: flex;
        width: 100%;
        align-items: center;
      }
    }

    .header-section {
      @include mq($from: desktop) {
        margin-inline-end: spacing(2);
      }
    }

    .multiple-cards {
      display: block;
      padding-block-start: 0;
      margin-block-start: 0;
    }

    .one-or-two-cards {
      align-items: center;
      @include mq($from: desktop) {
        display: flex;
        flex-direction: row;
      }
    }
  }
</style>

<div class="background">
  <Navbar
    bind:cards
    active={activeIdx}
    {data}
    {navbarTopPosition}
    on:cardSelected={handleNavbarCardSelected}
  >
    <div class="wrap" id="subscriptionSelectionComponent" dir={isRTL ? 'rtl' : null}>
      <div
        class="subscription-main-wrapper"
        class:multiple-cards={subscriptionCards > 1}
        class:one-or-two-cards={subscriptionCards < 3}
      >
        <div class="header-section">
          <USPSection {componentInformationKeys} {subscriptionCards} />
          <InfoBoxSection data={subscriptionData} {componentInformationKeys} />
        </div>
        <SubscriptionSelectionArea
          {sthp}
          data={subscriptionData}
          bind:cards
          {componentInformationKeys}
          {urlStyleLocale}
        />
      </div>
      <div bind:this={bottom} />
    </div>
  </Navbar>
  <Footer {componentInformationKeys} {sthp} data={subscriptionData} />
</div>
<svelte:window on:scroll={onScroll} />
